// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1fcab896","453":"849bb9cb","455":"9563f9c1"}[chunkId] + ".chunk.js";
};